/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updateOptionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
import { setActiveSelection } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import AnswerImage2 from 'material/embeds/content/shared/answer/image2/image2';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : IMAGE 2 : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    isValid: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['isValid'],
    isEditable: embedsState.embedManagementState.contentStatus.selectedContent === contentId,
    isSelected: embedsState.embedManagementState.contentStatus['activeSelection'].includes('option') && embedsState.embedManagementState.contentStatus['activeSelection'] === `option_${optionId}`,
    imageProvider: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageProvider'],
    imageID: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageID'],
    imageURL: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageURL'],
    previewImageURL: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['previewImageURL'],
});

const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),
    updateOptionProperty: (contentId, optionId, propertyName, value) => dispatch(updateOptionProperty(contentId, optionId, propertyName, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerImage2);
